import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-details.module.scss';
import Header from '../../../../../../../components/Stake/header';
import RfuelIcon from '../../../../../../../assets/images/tokens/rfuel.svg';
import * as rfuelStakeActions from '../../../../../../../actions/rfuel-stake-actions';
import { RFUEL, TOKEN_OPTIONS } from '../../../../../../../constants/blockchain-constants';
import { formatToken } from '../../../../../../../helpers/token-helper';
import { formatPrecision } from '../../../../../../../helpers/function-helper';

const StakeDetails = () => {
  const dispatch = useDispatch();
  const { amount } = useSelector((state) => state.RFUELstake.stake);

  return (
    <>
      <Header
        icon={RfuelIcon}
        title='RFUEL-Staking'
        onClickBack={() => dispatch(rfuelStakeActions.stakeSettings())}
      />
      <div className={stylesParent.cardContent}>
        <div>
          <div className={stylesParent.cardTextRow}>
            <div className={stylesParent.cardTextRowLabel}>You Are Staking:</div>
            <div className={stylesParent.cardTextRowValue}>
              <b>
                {formatToken(amount)} {RFUEL}
              </b>
            </div>
          </div>
          <div className={stylesParent.cardTextRow}>
            <div className={stylesParent.cardTextRowLabel}>Estimated APR:</div>
            <div className={stylesParent.cardTextRowValue}>
              <b>{formatPrecision(TOKEN_OPTIONS[RFUEL].initialCoeff * 100, 2)}%</b>
            </div>
          </div>
        </div>
        <div className={styles.descriptionContainer}>
          <div className={styles.descriptionItem}>
            <span>*</span> Staking will start immediately after clicking &quot;Stake Now&quot; but
            staking rewards will not be generated until <b>24 hours after.</b>
          </div>
          <div className={styles.descriptionItem}>
            <span>**</span> Unlike some other staked assets, there is no set duration for the
            staking of RFUEL. You may unstake your tokens at any time <b>without penalties.</b>{' '}
            There is an 8 day unstaking period you must wait before withdrawing your staked tokens.
          </div>
        </div>
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => dispatch(rfuelStakeActions.stakeSend({ amount }))}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Stake Now
          </Button>
        </div>
      </div>
    </>
  );
};

export default StakeDetails;
